<template>
  <div class="cam-layout">
    <!-- <img
      src="../assets/img/login/background.jpg"
      class="background-image"
      :class="{ blur: $route.path !== '/' }"
      alt=""
    />
    <div class="frame" v-if="$route.path !== '/'">
      <img src="../assets/img/bamboo.png" class="frame-image left" alt="" />
      <img src="../assets/img/bamboo.png" class="frame-image right" alt="" />
    </div> -->
    <!-- <div id="info" style="display:none"></div>
    <div id="loading">Loading the model...</div> -->

    <div id="main" :class="{ shown: isData }">
      <video
        onloadeddata="console.log('loaded video'); window.loadedVideo();"
        id="video"
        playsinline
        style=" -moz-transform: scaleX(-1);
        -o-transform: scaleX(-1);
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
        display: none;
        "
      ></video>
      <div class="canvas-wrapper">
        <canvas
          ref="posenetOutput"
          id="output"
          class="fade-in"
          :class="{ shown: isData }"
        />
        <div class="overlay-div" @mousemove="activeViewCursorHandler">
          <Dialog ref="dialog" />
          <router-view ref="activeView" :is-data="isData"></router-view>
        </div>
      </div>
    </div>
    <div class="back-sound">
      <audio id="back-sound">
        <source src="../assets/sound/cancel_exit.wav" type="audio/ogg" />
      </audio>
    </div>
    <div class="spinner" v-if="!isData">
      <img src="../assets/img/animations/spinner.gif" alt="" />
    </div>
  </div>
</template>

<script>
import layoutLogic from '../logic/layout-logic';
import { bindPage } from '../util/camera-util';
import appConfig from '../config/config';
import appConstants from '../config/constants';
import vowelsRegocnition from '../logic/vowels-regocnition';
import Dialog from '@/components/general/Dialog';
import cursorMixins from '../mixins/cursor-mixins.js';

export default {
  name: 'CamLayout',
  components: {
    Dialog
  },
  mixins: [cursorMixins],
  data() {
    return {
      // fadeEnder: true,
      // fadeLeave: false,
      isData: false,
      hoverableButtonsData: [],
      unhoverCounter: 0,
      // TODO: Store hover information here and make decisions about dispatching HOVER/ACTIVATE events,
      // according to the hover time required for activation.
      // If in the current camera input processing cycle nothing is hovered but there is data here,
      // then an UNHOVER event needs to be dispatched, and this object has to be reset.
      lastHoveredBtn: {
        handler: null,
        hoverStartedAt: null
      },
      hoverableBtnsRelodedCounter: 0,
      // used to prevent concurrent selection of yesPic && noPic
      handlerIdArr: []
    };
  },
  computed: {
    defineOverlayDivPos() {
      let width = Math.max(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      );
      let scrollBarWidth = layoutLogic.isDesktop()
        ? layoutLogic.getScrollbarWidth() / 2
        : layoutLogic.getScrollbarWidth();
      let leftMargin = width / 2 - scrollBarWidth - 300;
      return leftMargin;
    }
  },
  created() {
    window.loadedVideo = () => {
      this.isData = true;
      this.reloadHoverableButtons();
    };
  },
  mounted() {
    // if (!this.$store.getters.getDevMode) {
    //   document.querySelector('.dg.main').classList.add('hidden');
    // }
    window.onload = () => {
      bindPage(this.processCameraFrame);
      this.$store.commit(
        'setReloadHoverableButtons',
        this.reloadHoverableButtons
      );
      this.reloadHoverableButtons();
      if (this.$refs.dialog) {
        this.$store.commit('setDialogConfirm', this.$refs.dialog.costumConfirm);
      }
    };
  },
  watch: {
    $route() {
      // debugger;
      setTimeout(() => this.reloadHoverableButtons(), 1000);
    }
  },
  // tried to add a fade effect to routes in and out. unstable, still needs some work
  methods: {
    activeViewCursorHandler() {
      if (this.$route.path.includes('game')) {
        this.cursorHandler();
      }
    },
    reloadHoverableButtons() {
      this.lastHoveredBtn = {};
      this.hoverableBtnsRelodedCounter++;
      let activeViewHovarableBtns = [];
      if (this.$refs.activeView.collectHoverableButtonsData) {
        activeViewHovarableBtns = this.$refs.activeView.collectHoverableButtonsData();
      }
      this.hoverableButtonsData = [
        ...activeViewHovarableBtns,
        ...this.$refs.dialog.collectHoverableButtonsData()
      ];
    },
    processCameraFrame(recognizedPeople) {
      if (recognizedPeople[0] && recognizedPeople[0].keypoints) {
        const keypoints = recognizedPeople[0].keypoints;
        // buttons hovering events section
        this.handleButtonInteractionEvents(keypoints);
        if (this.$refs.activeView.getVowelToDetect) {
          // vowel detection section
          const vowelToDetect = this.$refs.activeView.getVowelToDetect();
          const vowelRecognitionFunc =
            appConstants.vowelFunctions[vowelToDetect];
          if (
            vowelToDetect /* type String */ &&
            vowelToDetect.length > 0 && // not a empty string
            vowelsRegocnition[vowelRecognitionFunc] // type function. test if function exists
          ) {
            this.handleVowelDetectionProcess(keypoints, vowelRecognitionFunc);
          }
        }
      }
    },
    initTestVowels(keypoints) {
      const recognizedVowelI = vowelsRegocnition.detectionProcessVowelI(
        keypoints
      );
      const recognizedVowelA = vowelsRegocnition.detectionProcessVowelA(
        keypoints
      );
      const recognizedVowelO = vowelsRegocnition.detectionProcessVowelO(
        keypoints
      );
      const recognizedVowelShva = vowelsRegocnition.detectionProcessVowelShva(
        keypoints
      );
      const recognizedVowelE = vowelsRegocnition.detectionProcessVowelE(
        keypoints
      );
      const recognizedVowelU = vowelsRegocnition.detectionProcessVowelU(
        keypoints
      );

      const vowelsDetectionObj = {
        VOWEL_I: recognizedVowelI,
        VOWEL_A: recognizedVowelA,
        VOWEL_O: recognizedVowelO,
        VOWEL_SHVA: recognizedVowelShva,
        VOWEL_E: recognizedVowelE,
        VOWEL_U: recognizedVowelU
      };

      this.$refs.activeView.testVowels(vowelsDetectionObj);
    },
    handleVowelDetectionProcess(keypoints, vowelRecognitionFunc) {
      if (this.$refs.activeView.hideUi) {
        // if ui is hidden due to dialog open, stop the process.
        return;
      }
      // using strategy
      // vowelsRecognition is a map of functions: { DETECT_VOWEL_I: function(){...} }
      // so this next line is similar to vowelsRecognition.DETECT_VOWEL_I(keypoints)
      // eslint-disable-next-line
      const recognizedVowel = vowelsRegocnition[vowelRecognitionFunc](keypoints);
      // recognizedVowel: String - constant name of a vowel. for example: VOWEL_E OR null OR false
      if (recognizedVowel) {
        this.$refs.activeView.handleVowelDetected(recognizedVowel);
      }
    },
    handleButtonInteractionEvents(keypoints) {
      const hoveredButton = this.findHoveredButton(keypoints);
      // exit hovering. will only stop hover if user stopped it for x times, to prevent unhover on unaccurate hovering.
      // sometmes the hover effect will 'flicker', resulting in unwanted unhover events.
      if (!hoveredButton && this.lastHoveredBtn.handler) {
        if (this.unhoverCounter >= appConfig.unhoverMitigator) {
          this.dispatchUnhoveredEvent();
          return;
        }
        // if unhover event happened but less than the unhoverMitigator times
        this.unhoverCounter += 1;
      }
      if (hoveredButton) {
        // activate event
        // console.log(
        //   `%c hover event ${hoveredButton.handlerId}`,
        //   'background: blue; color: #fff; font-size: 40px;'
        // );
        if (
          this.lastHoveredBtn.hoverStartedAt &&
          this.isHoveringDurationLongEnough() &&
          // only activate if the hovered btn is also the last hovered btn
          this.lastHoveredBtn.handler === hoveredButton.handlerId
        ) {
          // only declare btn active if its been hovering long enought.
          this.dispatchActivateEvent(hoveredButton);
          return;
        }
        // if found a hoveredBtn but not active, its hover event.
        this.dispatchHoverEvent(hoveredButton);
      }
    },
    handleYesNoPics(hoveredButton) {
      const isYesPic = hoveredButton.handlerId === appConstants.yesPic;
      const isNoPic = hoveredButton.handlerId === appConstants.noPic;
      if (isYesPic || isNoPic) {
        this.handlerIdArr.push(hoveredButton.handlerId);
        if (isYesPic) {
          // return false if there are no past selections of no Pic and yes pic is the current selected pic.
          return this.handlerIdArr.includes(appConstants.noPic);
        }
        if (isNoPic) {
          // return false if there are no past selections of yes Pic and no pic is the current selected pic.
          return this.handlerIdArr.includes(appConstants.yesPic);
        }
      }
    },
    isHoveringDurationLongEnough() {
      return (
        // adding a second to the time the hover started at. if a second has passed,
        // duration is long enought and the event is activate (and not hover).
        this.lastHoveredBtn.hoverStartedAt + appConfig.MAX_UNHOVER_COUNTER <=
        new Date().getTime()
      );
    },
    dispatchHoverEvent(hoveredButton) {
      if (this.$refs.dialog.show) {
        this.$refs.dialog.handleHoverEvent(hoveredButton.handlerId);
      }
      if (this.$refs.activeView.isMixins && !this.$refs.activeView.hideUi) {
        this.$refs.activeView.handleHoverEvent(hoveredButton.handlerId);
      }
      this.setLastHoveredBtn(hoveredButton);
    },
    dispatchActivateEvent(hoveredButton) {
      if (this.$refs.dialog.show) {
        this.$refs.dialog.handleActivateEvent(hoveredButton.handlerId);
      }
      if (this.$refs.activeView.isMixins && !this.$refs.activeView.hideUi) {
        this.$refs.activeView.handleActivateEvent(hoveredButton.handlerId);
      }
    },
    dispatchUnhoveredEvent() {
      this.handlerIdArr = [];
      if (this.$refs.dialog.show) {
        this.$refs.dialog.handleUnhoverEvent(this.lastHoveredBtn.handler);
      }
      if (this.$refs.activeView.isMixins && !this.$refs.activeView.hideUi) {
        this.$refs.activeView.handleUnhoverEvent(this.lastHoveredBtn.handler);
      }
      // reset handler and time for hovered btn
      this.lastHoveredBtn = {};
    },
    setLastHoveredBtn(hoveredButton) {
      this.lastHoveredBtn.handler = hoveredButton.handlerId;
      if (
        !this.lastHoveredBtn.hoverStartedAt ||
        this.lastHoveredBtn.handler !== hoveredButton.handlerId // if another btn is hovered, restart the time count!
      ) {
        // hoverStartedAt will only be populated if the item was being hovered & it wasn't hovered last time a keypoint was checked.
        // it will reset on unhover!
        this.lastHoveredBtn.hoverStartedAt = new Date().getTime();
      }
    },
    // TODO: Consider adding support for case that 2 buttons hare hovered
    findHoveredButton(keypoints) {
      let leftHandPos = null;
      let rightHandPos = null;

      let rightWrist = keypoints[10];
      if (rightWrist.part === 'rightWrist') {
        rightHandPos = rightWrist.position;
      }
      let leftWrist = keypoints[9];
      if (leftWrist.part === 'leftWrist') {
        leftHandPos = leftWrist.position;
      }
      // Searching for a button corresponding to the coordinates
      let hoveredButtonRight = null;
      let hoveredButtonLeft = null;
      if (this.hoverableButtonsData && this.hoverableButtonsData.length > 0) {
        // TODO: Check what to do if both hands are hovering over differnt buttons
        // (Presently, the right hand will take precedence)

        if (rightHandPos) {
          hoveredButtonRight = this.hoverableButtonsData.find(hoverableButton =>
            layoutLogic.isPointInRect(
              hoverableButton.rect,
              rightHandPos.x,
              rightHandPos.y
            )
          );
        }
        if (leftHandPos) {
          hoveredButtonLeft = this.hoverableButtonsData.find(hoverableButton =>
            layoutLogic.isPointInRect(
              hoverableButton.rect,
              leftHandPos.x,
              leftHandPos.y
            )
          );
        }
      }
      if (hoveredButtonLeft && hoveredButtonRight) {
        // prevent 2 pictures from being selected
        return null;
      }
      return hoveredButtonLeft || hoveredButtonRight;
    },
    isCamShown() {
      return this.$route.path !== '/' && this.$route.path !== '/tutorial';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.background-image {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  transition: filter 0.5s;
  width: 100vw;
  height: 100vh;
  filter: none;
  &.blur {
    filter: blur(5px);
  }
}

.frame-image {
  position: fixed;
  top: 0;
  // right: $posX;
  z-index: 200;
  // bottom: $posY;
  &.left {
    left: calc(#{$posX} - 40px);
  }
  &.right {
    right: calc(#{$posX} - 40px);
  }
}

.hide-mouse {
  cursor: none;
}

.fading-view {
  opacity: 1;
  transition: opacity 0.5s;
}
.fade-enter {
  opacity: 1;
}
.fade-leave {
  opacity: 0;
}

.full-size {
  height: 100%;
  width: 100%;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.canvas-wrapper {
  position: relative;
}

.overlay-div,
canvas {
  //positioned on top of each other
  position: fixed;
  top: $posY;
  right: $posX;
  left: $posX;
  bottom: $posY;
}

.button-inside {
  border: 1px solid black;
  background-color: white;
  position: absolute;
  padding: 5px;
  margin: 5px;
  border-radius: 10px;
  box-shadow: 1px 1px 10px -2px black;
  cursor: pointer;
  transition: 0.5s;
}

.button-right {
  right: 0;
}

.button-inside-js {
  font-size: 14pt;
  font-weight: bold;
}

.button-inside:hover {
  background-color: red;
  transition: 0.5s;
}

canvas {
  position: fixed;
  top: $posY;
  right: $posX;
  left: $posX;
  // bottom: $posY;
}

.spinner {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
